import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const AlertSpot = ({
  spotFillColor = '#9B0021',
  spotHeight = '24',
  spotViewBox = '0 0 24 24',
  spotWidth = '24',
  ...svgProps
}: IconProps = {}): React.ReactElement => {
  return (
    <svg
      width={spotWidth}
      height={spotHeight}
      viewBox={spotViewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M21.6399 17.3403L14.0499 4.20031C13.1299 2.61031 10.8299 2.61031 9.90989 4.20031L2.31989 17.3403C1.39989 18.9303 2.54989 20.9303 4.38989 20.9303H19.5699C21.4099 20.9303 22.5599 18.9303 21.6399 17.3403ZM11.2599 7.91031H12.7099C12.9699 7.91031 13.1799 8.16031 13.1599 8.44031L12.6599 13.9703C12.6499 14.1203 12.5299 14.2403 12.3899 14.2403H11.6099C11.4699 14.2403 11.3499 14.1203 11.3399 13.9703L10.8099 8.45031C10.7899 8.16031 10.9899 7.91031 11.2599 7.91031ZM11.9899 18.1003C11.3499 18.1003 10.8199 17.5803 10.8199 16.9303C10.8199 16.2903 11.3499 15.7603 11.9899 15.7603C12.6399 15.7603 13.1599 16.2903 13.1599 16.9303C13.1599 17.5803 12.6399 18.1003 11.9899 18.1003Z"
        fill={spotFillColor}
      />
    </svg>
  );
};
